import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteHashtag = async (uuid: string) => {
	const response = await cmsClient.delete(`/homepage/admin/hashtags/${uuid}/`);

	return response.data;
};

const useDeleteHashtag = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Hashtag deleted successfully" />,
			{ hideProgressBar: true }
		);
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["admin-hashtags"]);
		queryClient.invalidateQueries(["favourite-feeds"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(deleteHashtag, {
		onError,
		onSuccess,
		onSettled
	});

	return mutation;
};

export default useDeleteHashtag;
